// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3-h9j","empty":"ModalGraph_empty__1GiFO"};